import React from 'react';
import Document from '../../_CustomComponents/DocumentV2';
import { connect } from "react-redux";
import BaseDocument from '../../_CustomComponents/BaseDocument';
import * as fileCrud from '../../../../crud/file.crud';
import { Alert } from "react-bootstrap";
import BiDynamicForm from '../../../../partials/layout/BiDynamicForm';
import { Validator, CustomRule, } from 'devextreme-react/validator';
import { CheckBox } from 'devextreme-react/check-box';
import moment from 'moment';
import { addDays } from 'date-fns';
import { FormattedMessage, injectIntl } from "react-intl";
import Common from '../../../../shared/common';
import DocumentDraftInfo from '../../_CustomComponents/DocumentDraftInfo';




class ReplyDocument extends BaseDocument {
    constructor(props) {
        super(props);
        const { replyFields } = this.props.workflowItem;
        this.rejectOptions = props.placeholders.find(ph => ph.replacementKey === 'ReplyRejectOptions')
            .values.filter(item => item.isActive === true);
        this.rejectOptions = this.rejectOptions.map(opt => ({ ...opt, validatorRef: React.createRef() }));
        
        const initialOptions = this.rejectOptions.reduce((obj, option) => ({ ...obj, [option.field]: props.reply[option.field] }), {});

        this.state = {
            rejectOptions: initialOptions,
            instructquote: props.reply?.instructquote !== false
        };
    }
    // componentDidUpdate(prevProps, prevState) {
    //     if (prevProps.notification.projectmanagersignedbyid !== this.props.notification.projectmanagersignedbyid) {
    //         this.userid = this.props.notification.projectmanagersignedbyid;
    //         this.fetchUser();
    //     }
    // }
    onCheckboxValueChanged = (field, value) => {
        const anyWasSelected = this.rejectOptions.some(type => this.state.rejectOptions[type.field] === true);
        this.state.rejectOptions[field] = value;

        //FIRST ITEM SELECTED
        if (anyWasSelected === false && value === true) {
            //CLEAR ANY VALIDATION ERRORS ON OTHER BOXES
            this.rejectOptions.forEach(itm => {
                if (itm.field !== field) {
                    itm.validatorRef.current.instance().reset()
                }
            });
        }
        this.props.fieldChanged(field, value);
    }
    renderCheckBoxItem = () => {
        return (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                {
                    this.rejectOptions.map((rejectOption, index) =>
                    (
                        <CheckBox
                            key={index}
                            style={{ marginTop: 7, marginBottom: 4 }}
                            defaultValue={this.state.rejectOptions[rejectOption.field] ? this.state.rejectOptions[rejectOption.field] : false}
                            onValueChanged={(args) => this.onCheckboxValueChanged(rejectOption.field, args.value)}
                            text={rejectOption.display} >
                            <Validator ref={rejectOption.validatorRef}>
                                <CustomRule
                                    type="custom"
                                    validationCallback={(e) => {
                                        if (e.value === true) { return true; }
                                        const validationresult = this.rejectOptions.some(opt => this.state.rejectOptions[opt.field] === true && opt.field !== rejectOption.field);
                                        return validationresult;
                                    }}
                                    message={this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING.ONE_OPTION_REQUIRED' })}
                                />
                            </Validator>
                        </CheckBox>
                    ))
                }
            </div>
        );
    }
    renderChackedRiskItems = () => {
        const items = this.rejectOptions.filter(itm => (this.props.notification[itm.field] && this.props.notification[itm.field] === 1));
        return (
            <ul style={{ listStyleType: 'none', paddingInlineStart: 0 }}>
                {items.map((item, index) => (
                    <li key={index}>
                        <i className="fas fa-chevron-right"></i>
                        <span style={{ paddingLeft: 5 }}>{item.display}</span>
                    </li>
                ))}
            </ul>
        );
    }

    renderForm = () => {
        const { props } = this;
        const { replyFields } = props.workflowItem;
        let replyAcceptedCommentLabel = props.resources.ReplyAcceptedCommentLabel.replace('$reference', this.props.notification.referenceid);
        const quoteRequiredDate = Common.GetCENQuoteRequiredDate(this.props.workflowItem, this.props.item?.notificationdate, new Date(), this.props.item?.eventawaredate, this.props.item?.instructiondate);

        const replyFormConfig = {
            fields: [
                { label: replyFields.QuoteRequired.label, dataField: 'quoterequired', editorType: 'dxSelectBox', editorOptions: { dataSource: replyFields.QuoteRequired.replyOptions, valueExpr: 'value', displayExpr: 'display' } },
                { label: props.resources.ReplyRejectedOptionsLabel, render: this.renderCheckBoxItem, visible: (obj) => obj.quoterequired === 0, },
                { label: replyAcceptedCommentLabel, dataField: 'eventcomment', editorType: 'dxHtmlEditor', visible: (obj) => obj.quoterequired === 1 },
                { 
                    label: replyFields.InstructQuote.label,
                    dataField: 'instructquote', 
                    editorType: 'dxCheckBox', 
                    visible: (obj) => (obj.quoterequired === 1 && this.props.workflowItem.quoteOptional),
                    editorOptions: {
                        // Control the value via state
                        value: this.state.instructquote,
                        onValueChanged: (e) => {
                            this.setState({ instructquote: e.value });
                            if (e.value === false) {
                                // Wipes the data when unchecked
                                this.props.fieldChanged('assumption', null);
                            }
                            this.props.fieldChanged('instructquote', e.value);
                        }
                    }
                },
                { 
                    note: (props.resources.ReplyAcceptedAssumptionNote || "").replace('$date', moment(quoteRequiredDate).format('DD/MM/YYYY')),
                    visible: (obj) => obj.quoterequired === 1 && (!this.props.workflowItem.quoteOptional || this.state.instructquote)
                },
                { label: props.resources.ReplyRejectedCommentLabel, dataField: 'eventcomment', editorType: 'dxHtmlEditor', visible: (obj) => obj.quoterequired === 0 },
                { label: props.resources.ReplyRejectedCommentLabel, dataField: 'eventcomment', editorType: 'dxHtmlEditor', visible: (obj) => obj.quoterequired === 2 },
            ]
        };

        if (props.mode !== "CLAIMWN" && props.mode !== "CLIENTCWN") {
            replyFormConfig.fields.push({ 
                label: replyFields.ReplyAcceptedAssumption.label, 
                dataField: 'assumption', 
                editorType: 'dxHtmlEditor',
                visible: (obj) => obj.quoterequired === 1 && (!this.props.workflowItem.quoteOptional || this.state.instructquote)
            });
        }

        return (
            <>
                {this.props.resources.SupplierCompensationReplyWarningBanner && (
                    <Alert variant="warning" >
                        <p>
                            {this.props.resources.SupplierCompensationReplyWarningBanner}
                        </p>
                    </Alert>
                )}
                <BiDynamicForm
                    isReply={true}
                    item={this.props.reply}
                    config={replyFormConfig}
                    valueChangeHandler={this.props.fieldChanged}
                    customFields={(this.props.customFields || {}).REPLY}
                />
            </>
        );
    }
    uploadFile = (data, config) => {
        const { companyid, projectid, contractid } = this.props.contract;
        return fileCrud.uploadContractNotificationFiles(companyid, projectid, contractid, this.props.documentType + 'Reply', this.props.notification.compensationeventid, this.props.workflowItem.id, this.props.workflowItem.config.quotationWorkflowID, data, config)
    }
    render() {

        const documentIsFinal = !this.props.isAwaitingReply;
        const { replycreatebyname, replycreatedate, draftreplyby, draftreplydate, draftreplyto } = this.props.notification;

        return (
            <>
                <DocumentDraftInfo
                    documentIsFinal={documentIsFinal}
                    createbyname={replycreatebyname}
                    createdate={replycreatedate}
                    lastdraftedbyname={draftreplyby}
                    lastdrafteddate={draftreplydate}
                    lastdraftednotifiedtoname={draftreplyto}
                    isReply={true}
                />
                <Document
                    key={documentIsFinal}
                    docConfig={this.props.notification.pdfreplyjsoncontent}
                    isFinal={documentIsFinal}
                    printDivRef={this.props.printDivRef}
                    workflowItem={this.props.workflowItem}
                    contract={this.props.contract}
                    reference={this.props.notification.referenceid}
                    form={documentIsFinal ? null : this.renderForm()}
                    uploadMethod={documentIsFinal ? null : this.uploadFile}
                    files={this.props.files}
                    notificationid={this.props.notificationid}
                    documentType={this.props.documentType}
                    isReply={true}
                    customFields={(this.props.customFields || {}).REPLY}
                    customFieldValues={this.props.notification.customfieldvalues}
                    assetid={this.props.notification.assetid}
                    saving={this.props.saving}
                    onFileUploadFinish={this.props.onFileUploadFinish}
                    onFileUploadStart={this.props.onFileUploadStart}
                />
            </>
        );
    }
}

const mapStateToProps = store => ({
    // globalResources: store.contract.template.resources,
});

export default injectIntl(connect(mapStateToProps)(ReplyDocument));
